package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.BlackOverlay
import com.anjuros.website.components.TemplatesHeader
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.detectLanguage
import com.anjuros.website.components.detectMode
import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.LanguageContext
import com.anjuros.website.components.language.LocalLanguage
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.language.isContentSelected
import com.anjuros.website.components.setMeta
import com.anjuros.website.components.shared.TemplatePromoFab
import com.anjuros.website.templates.mix.modules.HintBoxDisplay
import com.anjuros.website.templates.selection.modules.Template
import com.anjuros.website.templates.selection.styles.HeaderHeight
import com.anjuros.website.templates.template10.components.Template10OverflowMenu
import com.anjuros.website.templates.template10.modules.Template10Theme
import com.anjuros.website.templates.template10.sections.Template10AboutSection
import com.anjuros.website.templates.template10.sections.Template10BenefitsSection
import com.anjuros.website.templates.template10.sections.Template10ContactSection
import com.anjuros.website.templates.template10.sections.Template10FooterSection
import com.anjuros.website.templates.template10.sections.Template10MainSection
import com.anjuros.website.templates.template10.sections.Template10TimetableSection
import com.anjuros.website.templates.template10.sections.Template10VideosSection
import com.anjuros.website.templates.template10.util.loadTemplate10Fonts
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.localStorage
import org.jetbrains.compose.web.css.Position

@Page
@Composable
fun InstructorWebsiteDesignUk() {
    var lang by remember { mutableStateOf(Language.EN) }
    val uiMode = remember { mutableStateOf<UiMode?>(null) }
    var showModeToggleSpotlight by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        setMeta(
            "Instructor website design UK | Tai Chi & fitness class websites",
            "Calm, modern website design for Tai Chi, yoga and fitness instructors in the UK. Show your timetable, videos and venues and get more bookings."
        )
        loadTemplate10Fonts()
        lang = detectLanguage()
        uiMode.value = detectMode()
        showModeToggleSpotlight =
            uiMode.value != null && localStorage.getItem(HintBoxDisplay).isNullOrEmpty()
    }

    val languageContext = remember(lang) {
        LanguageContext(
            lang = lang,
            setLang = { lang = it }
        )
    }

    var menuOpened by remember { mutableStateOf(false) }

    val contentMode = uiMode.value ?: UiMode.NORMAL

    CompositionLocalProvider(
        LocalLanguage provides languageContext,
        LocalUiMode provides contentMode
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Template10Theme.Paper.rgb)
        ) {
            Column(
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Template10MainSection(
                    modifier = HeaderHeight.toModifier()
                ) {
                    menuOpened = true
                }
                Template10BenefitsSection()
                Template10AboutSection()
                Template10VideosSection()
                Template10TimetableSection()
                Template10ContactSection(
                    showContactForm = true
                )
                Template10FooterSection()
            }
            if (showModeToggleSpotlight) {
                BlackOverlay()
            }
            TemplatesHeader(
                modifier = Modifier.align(Alignment.TopCenter)
                    .position(Position.Fixed)
                    .zIndex(100),
                template = Template.Template10,
                showModeToggleSpotlight = showModeToggleSpotlight,
                onDismissSpotlight = {
                    showModeToggleSpotlight = false
                },
                contentModeSelected = uiMode.value.isContentSelected(),
                onChangeMode = { newMode ->
                    uiMode.value = newMode
                    changeMode(newMode)
                }
            )
            if (menuOpened) {
                Template10OverflowMenu { menuOpened = false }
            }
            TemplatePromoFab()
        }
    }
}
